var map = {
	"./file-icon_doc.svg": "ce43",
	"./file-icon_docx.svg": "e945",
	"./file-icon_jpeg.svg": "0f01",
	"./file-icon_jpg.svg": "828a",
	"./file-icon_mov.svg": "4477",
	"./file-icon_mp3.svg": "6bce",
	"./file-icon_mp4.svg": "0c1d",
	"./file-icon_other.svg": "28f6",
	"./file-icon_pdf.svg": "0623",
	"./file-icon_png.svg": "9e0a",
	"./file-icon_ppt.svg": "ca9a",
	"./file-icon_pptx.svg": "ec08",
	"./file-icon_psd.svg": "b6e1",
	"./file-icon_svg.svg": "750c",
	"./file-icon_wav.svg": "416e",
	"./file-icon_xls.svg": "41ff",
	"./file-icon_xlsx.svg": "4d57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d4fc";